export default function RetirementDatePlanning({}) {
  return (
    <div className="col-lg-12" style={{ height: "100%", padding: 50 }}>
      <h3
        style={{
          textAlign: "center",
          fontWeight: "normal",
          fontSize: 22,
          lineHeight: 2,
        }}
      >
        <br />

        <p>Retirement date planning is coming soon!</p>
      </h3>
    </div>
  );
}
